import React from 'react';
import { Spinner, Page } from '@shopify/polaris';

export const LoadingSpinner: React.FC = () => {
  return (
    <Page>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Spinner size="large" />
      </div>
    </Page>
  );
}; 